module.exports = __webpack_public_path__ + "images/logo_dark_blue.png";